import { distanceUtil } from '../../lib/distanceUtil-sidecar'
import { rando } from '../../lib/rando-sidecar'
import { common } from '../../main/common-sidecar'
import { voyageCamera_shaker } from './voyageCamera_shaker-sidecar'
import { EVoyageCrewType } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageParticles } from './voyageParticles-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'

export interface IVoyageEnemyShip {
  active: boolean
  class: string
  hitpoints: number
  fireTimer: number
  fireTime: number
  fireSize: number

  chanceFire: number
  chanceBreach: number
}

export function create(): IVoyageEnemyShip {
  return {
    active: false,
    class: 'Noclass',
    hitpoints: 0,
    fireTimer: 0,
    fireTime: 100,
    fireSize: 0,
    chanceBreach: 0,
    chanceFire: 0,
  }
}

export function update() {
  let obj = voyageGameStatus.get()
  let ds = common.getUpdateDeltaScaled()

  let es = obj.enemyShip
  if (es.active) {
    es.fireTimer += ds
    if (es.fireTimer > es.fireTime) {
      es.fireTimer -= es.fireTime

      hitByWeapon(es.fireSize, es.chanceFire, es.chanceBreach)
    }
  }
}

export function hitByWeapon(
  size: number,
  chanceFire: number,
  chanceBreach: number,
  shake: boolean = true,
) {
  let floor = voyageTilemap.getRandomFloor()

  let r = Math.ceil(size)

  voyageParticles.createMultiple('weapon-hit', floor.x, floor.y, 5 * size)

  let createdFire = 0
  let createdBreach = 0

  //console.log('breach', es.fireSize)
  for (let i = -r; i <= r; i++) {
    for (let j = -r; j <= r; j++) {
      let d = distanceUtil.distanceNormal(i, j, 0, 0)
      //let d = 0/
      if (d <= size) {
        let t = voyageTilemap.getSafeOffset(floor, i, j)

        // console.log('breach t', t)

        if (t && t.tile2.canWalk) {
          if (!t.breach && !t.fire) {
            if (rando.chance(chanceFire)) {
              let cr = voyageCrew.create(EVoyageCrewType.Fire, -1)
              createdFire++
              voyageCrew.moveToIJ(cr, t)
            } else if (rando.chance(chanceBreach)) {
              let cr = voyageCrew.create(EVoyageCrewType.HullBreach, -1)
              voyageCrew.moveToIJ(cr, t)
              createdBreach++
            }
          }
        }
      }
    }
  }

  if (createdFire > 0) {
  }
  if (createdBreach > 0) {
    //if(rando.chance())
    voyageSounds.playExplosionMetalDebris()
  }

  if (createdFire > createdBreach) {
    voyageSounds.playExplosionFire()
  } else {
    voyageSounds.playExplosion()
  }

  if (shake) {
    voyageCamera_shaker.shake()
  }
}

export function createHammerheadClass() {
  let obj = voyageGameStatus.get()
  let es = obj.enemyShip

  es.chanceFire = 0.1
  es.chanceBreach = 0.3
  es.fireTime = 10
  es.fireTimer = 0
  es.fireSize = 1.5
  es.hitpoints = 100
  es.class = 'Hammerhead'
  es.active = true
}

export function hurt(damage: number) {
  let obj = voyageGameStatus.get()
  let es = obj.enemyShip

  if (es.active) {
    es.hitpoints -= damage
    if (es.hitpoints <= 0) {
      es.active = false
      voyageGameStatus.addShipsDead()
      setTimeout(() => {
        voyageSounds.playEnemyShipDefeated()
      }, 2000)
    }
  }
}
